<template>
  <div v-if="show" class="batch-size-warning">
    <i class="fas fa-info-circle mr-1"></i>
    <span>
      Số lượng lớn ({{ count }} hóa đơn). Nên dùng chế độ
      <strong>"Dùng chung"</strong> hoặc tách thành nhiều đợt nhỏ hơn (~{{ threshold }}/đợt).
    </span>
  </div>
</template>

<script>
export default {
  name: 'BatchSizeWarning',
  props: {
    count: { type: Number, default: 0 },
    threshold: { type: Number, default: 30 },
  },
  computed: {
    show() {
      return this.count > this.threshold;
    },
  },
};
</script>

<style lang="scss" scoped>
$draft-radius: 0.375rem;

.batch-size-warning {
  padding: 0.5rem 0.75rem;
  background: #eee5ff;
  border-radius: $draft-radius;
  font-size: 0.78rem;
  color: #8950fc;
  margin-bottom: 0.75rem;

  i { color: #8950fc; }
}
</style>
